import { render, staticRenderFns } from "./FlowNode.vue?vue&type=template&id=12548a40"
import script from "./FlowNode.vue?vue&type=script&lang=js"
export * from "./FlowNode.vue?vue&type=script&lang=js"
import style0 from "./FlowNode.vue?vue&type=style&index=0&id=12548a40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports